var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2,16.06l-1.46-1.47V10.92a6,6,0,0,0-5.09-6A5.91,5.91,0,0,0,6,10a6.47,6.47,0,0,0,0,.76v3.85L4.52,16.06a1.53,1.53,0,0,0-.45,1.13,1.59,1.59,0,0,0,1.58,1.58H8.28v.08a3.45,3.45,0,0,0,3.42,3.3h.15a3.45,3.45,0,0,0,3.6-3.3v-.07h2.62a1.59,1.59,0,0,0,1.13-.47,1.59,1.59,0,0,0,0-2.24Zm-8.81,2.78v-.07h2.95v.06A1.38,1.38,0,0,1,11.85,20,1.37,1.37,0,0,1,10.39,18.84ZM16.18,16l.64.64H6.9L7.53,16a1.88,1.88,0,0,0,.56-1.34V10.74A3.83,3.83,0,0,1,12.37,7a3.89,3.89,0,0,1,3.26,3.92v3.8A1.88,1.88,0,0,0,16.18,16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4,2.15A10.12,10.12,0,0,0,3,5.79L4.71,7A8.14,8.14,0,0,1,7.48,4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6,2.15a10.12,10.12,0,0,1,3.45,3.64L19.29,7a8.14,8.14,0,0,0-2.77-3Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGong);
export default __webpack_public_path__ + "static/media/gong.fd12bfef959917cf733dd7abd7b84ce0.svg";
export { ForwardRef as ReactComponent };